"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _randomId = _interopRequireDefault(require("../../utils/randomId"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  offset: [0, 0],
  position: 'top',
  style: {
    marginLeft: 0,
    marginTop: 0
  },
  theme: {},
  hasNoTabIndex: false
};

/**
 * Adds a tooltip to an element.
 */
var Tooltip = exports["default"] = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Tooltip, _Component);
  function Tooltip(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Tooltip);
    _this = _callSuper(this, Tooltip, [props]);
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseEnter = _this.handleMouseEnter.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseLeave = _this.handleMouseLeave.bind((0, _assertThisInitialized2["default"])(_this));
    // A random unique id is generated for each aria-describedby attribute so they won't collide
    _this.randomId = (0, _randomId["default"])();
    _this.state = {
      isTooltipOpen: false
    };
    return _this;
  }
  (0, _createClass2["default"])(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.correctTooltipPosition();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.resetTooltipPosition();
      this.correctTooltipPosition();
    }
  }, {
    key: "accessibilityId",
    get: function get() {
      var ariaDescribedByTrigger = this.props.ariaDescribedByTrigger;
      return "accessibility-text-".concat(ariaDescribedByTrigger || this.randomId);
    }
  }, {
    key: "getClassNames",
    value: function getClassNames() {
      var _this$props = this.props,
        position = _this$props.position,
        theme = _this$props.theme;
      var classes = (0, _classnames["default"])(this.state.isTooltipOpen ? theme['tooltip-visible'] : null, theme.tooltip, /* localized styles */
      theme["tooltip-position-".concat(position)]);
      return classes;
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.setState({
        isTooltipOpen: true
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        isTooltipOpen: false
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.setState({
          isTooltipOpen: false
        });
      }
    }
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      this.setState({
        isTooltipOpen: true
      });
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      this.setState({
        isTooltipOpen: false
      });
    }
  }, {
    key: "resetTooltipPosition",
    value: function resetTooltipPosition() {
      var _this$props2 = this.props,
        offset = _this$props2.offset,
        theme = _this$props2.theme;
      this.tooltipInnerEl.style.marginLeft = "".concat(offset[0], "px");
      this.tooltipInnerEl.style.width = '';
      this.tooltipInnerEl.classList.remove(theme['tooltip-inner-multi-line']);
    }
  }, {
    key: "correctTooltipPosition",
    value: function correctTooltipPosition() {
      if (!this.tooltipInnerEl) {
        // This will happen during shallow mounting in tests.
        return;
      }
      var theme = this.props.theme;
      var tooltipBoundingRect = this.tooltipInnerEl.getBoundingClientRect();
      var clientWidth = document.documentElement.clientWidth;
      if (tooltipBoundingRect.width + Tooltip.defaultSideOffset * 2 > clientWidth) {
        this.tooltipInnerEl.classList.add(theme['tooltip-inner-multi-line']);
        this.tooltipInnerEl.style.width = "".concat(clientWidth - Tooltip.defaultSideOffset * 2, "px");
        this.tooltipInnerEl.style.marginLeft = "".concat(tooltipBoundingRect.left * -1 - (tooltipBoundingRect.width - clientWidth) / 2, "px");
      } else if (tooltipBoundingRect.left - Tooltip.defaultSideOffset < 0) {
        this.tooltipInnerEl.style.marginLeft = "".concat(tooltipBoundingRect.left * -1 + Tooltip.defaultSideOffset, "px");
      } else if (tooltipBoundingRect.right - clientWidth + Tooltip.defaultSideOffset > 0) {
        this.tooltipInnerEl.style.marginLeft = "-".concat(tooltipBoundingRect.right - clientWidth + Tooltip.defaultSideOffset, "px");
      }
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip() {
      var _this2 = this;
      var _this$props3 = this.props,
        offset = _this$props3.offset,
        content = _this$props3.content,
        style = _this$props3.style,
        testId = _this$props3.testId,
        theme = _this$props3.theme;
      var tooltipContent = '';
      if (typeof content === 'string') {
        tooltipContent = /*#__PURE__*/_react["default"].createElement("span", {
          id: this.accessibilityId,
          role: "tooltip",
          "aria-hidden": !this.state.isTooltipOpen,
          className: theme['tooltip-text'],
          "data-test-id": testId && "".concat(testId, "-text")
        }, content);
      } else if (content && content.type) {
        tooltipContent = /*#__PURE__*/_react["default"].cloneElement(content, {
          id: this.accessibilityId
        });
      }

      // Add offset to the styles, overriding
      // marginLeft and marginTop (if present)
      var styleWithOffset = _objectSpread(_objectSpread({}, style), {}, {
        marginLeft: offset[0],
        marginTop: offset[1]
      });
      var tooltip = /*#__PURE__*/_react["default"].createElement("div", {
        style: styleWithOffset,
        ref: function ref(r) {
          return _this2.tooltipInnerEl = r;
        },
        className: this.getClassNames(),
        "data-test-id": testId && "".concat(testId, "-inner")
      }, tooltipContent);
      return tooltip;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        children = _this$props4.children,
        hasNoTabIndex = _this$props4.hasNoTabIndex,
        testId = _this$props4.testId,
        className = _this$props4.className,
        theme = _this$props4.theme;
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])(theme['tooltip-wrap'], className),
        "data-test-id": testId,
        "data-anypoint-component": Tooltip.displayName
      }, /*#__PURE__*/_react["default"].createElement("span", {
        tabIndex: hasNoTabIndex ? -1 : 0,
        "aria-describedby": this.accessibilityId,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        className: theme['tooltip-children-wrapper'],
        onKeyDown: this.handleKeyDown,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        "data-test-id": testId && "".concat(testId, "-children-wrapper")
      }, children), this.renderTooltip());
    }
  }]);
  return Tooltip;
}(_react.Component);
(0, _defineProperty2["default"])(Tooltip, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(Tooltip, "displayName", 'Tooltip');
(0, _defineProperty2["default"])(Tooltip, "defaultSideOffset", 10);
//# sourceMappingURL=Tooltip.js.map